<template>
  <div class="gs-checkout-builder-step gs-checkout-code-step">
    <div class="gs-checkout-code-step__notice">
      <info-icon aria-hidden="true" />
      <div>
        <strong>Advanced checkout code</strong>
        <span>{{ $t('frontend_product_step5_note') }} Only paste code from a source you trust.</span>
      </div>
    </div>
    <section class="gs-checkout-code-step__editor">
      <div class="gs-checkout-code-step__copy">
        <label>{{ $t('frontend_product_step5_custom_css_track') }}</label>
        <p>Add checkout-specific CSS or tracking scripts. These changes apply only to this checkout experience.</p>
      </div>
      <text-area
        v-model="prductDetails.checkout_page_options.tracking_codes"
        class="gs-checkout-code-step__textarea"
        value="prductDetails.checkout_page_options.tracking_codes"
        :placeholder="$t('frontend_product_step5_custom_css_track')"
        :aria-label="$t('frontend_product_step5_custom_css_track')"
      />
    </section>
  </div>
</template>

<script>
import InfoIcon from '@/assets/images/icons/InfoIcon.svg';

export default {
  name: 'CustomCssStep',

  components: {
    InfoIcon,
  },

  props: {
    prductDetails: {
      required: true,
    },
    model: {
      required: true,
    },
  },

  data() {
    return {
    };
  },
  methods: {
    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },
};
</script>

<style scoped>
.gs-checkout-code-step {
  display: grid;
  gap: 18px;
}

.gs-checkout-code-step__notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  color: #315d8a;
  background: #eef7ff;
  border: 1px solid #cee7ff;
  border-radius: 10px;
}

.gs-checkout-code-step__notice svg {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  fill: currentColor;
}

.gs-checkout-code-step__notice strong,
.gs-checkout-code-step__notice span {
  display: block;
}

.gs-checkout-code-step__notice strong {
  font-size: 12px;
  font-weight: 800;
}

.gs-checkout-code-step__notice span {
  margin-top: 3px;
  font-size: 11px;
  line-height: 1.5;
}

.gs-checkout-code-step__editor {
  padding: 20px;
  background: #fff;
  border: 1px solid var(--gs-border, #e2e8f0);
  border-radius: 12px;
}

.gs-checkout-code-step__copy {
  margin-bottom: 12px;
}

.gs-checkout-code-step__copy label {
  color: var(--gs-foreground, #182230);
  font-size: 13px;
  font-weight: 800;
}

.gs-checkout-code-step__copy p {
  margin: 4px 0 0;
  color: var(--gs-muted-foreground, #667085);
  font-size: 11px;
  line-height: 1.5;
}

.gs-checkout-code-step__textarea {
  width: 100%;
  min-height: 260px;
  font-family: var(--gs-font-mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace);
}
</style>
